export enum QueryKey {
  Authentication = "Authentication",
  Tenant = "Tenant",
  Role = "Role",
  Person = "Person",
  GoogleCloudStorage = "GoogleCloudStorage",
  Patient = "Patient",
  UtilService = "UtilService",
  Contract = "Contract",
  Billing = "Billing",
  ProviderType = "ProviderType",
  Payment = "Payment",
  Dashboard = "Dashboard",
  Visit = "Visit",
  AttachmentVisit = "AttachmentVisit",
  Waiver = "Waiver",
  Registration = "Registration",
  UtilCategory = "UtilCategory",
  ClinicSchedule = "ClinicSchedule",
  ScheduleException = "ScheduleException",
  AvailableSlots = "AvailableSlots",
  ActivityLog = "ActivityLog",
  Discount = "Discount",
  // KEY ADD
}
